import { MYT_OFFSET_MS, mytClock, mytDayLabel } from './timeline/dropLogic.js';

/**
 * 320 (#635, research R4) — the free-for window as the operator types it: Malaysia wall clock,
 * `YYYY-MM-DDTHH:mm` (the `datetime-local` format), in the address; instants on the wire. Malaysia
 * time is a fixed +8 h, read with UTC getters only (the 284 rule), so a browser in another zone
 * sends the same instants.
 */

const WALL = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/;
const MAX_MS = 42 * 24 * 60 * 60 * 1000;

export const isWall = (s: string): boolean => WALL.test(s);

function wallMs(wall: string): number {
  const m = WALL.exec(wall);
  if (!m) return Number.NaN;
  const [y, mo, d, h, mi] = m.slice(1).map(Number) as [number, number, number, number, number];
  return Date.UTC(y, mo - 1, d, h, mi) - MYT_OFFSET_MS;
}

export function wallToInstant(wall: string): string {
  return new Date(wallMs(wall)).toISOString();
}

export function instantToWall(iso: string): string {
  return new Date(Date.parse(iso) + MYT_OFFSET_MS).toISOString().slice(0, 16);
}

/** Q1: whole days — the viewed day 00:00 to the next day 00:00, so the times can be left alone. */
export function prefillFor(day: string): { from: string; to: string } {
  const start = Date.parse(`${day}T00:00:00.000Z`);
  const next = new Date(start + 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
  return { from: `${day}T00:00`, to: `${next}T00:00` };
}

/** FR-008 — the server's rule, said before the request: null when the window is valid. */
export function validFreeWindow(from: string, to: string): string | null {
  if (!isWall(from) || !isWall(to)) return 'Choose a start and an end.';
  const span = wallMs(to) - wallMs(from);
  if (span <= 0) return 'The end must be after the start.';
  if (span > MAX_MS) return 'The window can be at most 42 days.';
  return null;
}

/** "Fri 2 Oct 10:00 – Sun 4 Oct 18:00". */
export function freeForLabel(from: string, to: string): string {
  const a = wallMs(from);
  const b = wallMs(to);
  return `${mytDayLabel(a)} ${mytClock(a)} – ${mytDayLabel(b)} ${mytClock(b)}`;
}
